import { formatarData } from '../../helpers/utils';

const resolver = key => {
  const keys = {
    webhookPagamentoParcela: 'Pagamento de Parcela',
    webhookPagamentoProtocolo: 'Pagamento de Protocolo',
    webhookPagamentoPedagio: 'Pagamento de Pedágio',
  };

  return keys[key];
};

export const colunas = [
  {
    title: 'Id',
    dataIndex: 'id',
  },
  {
    title: 'Data',
    dataIndex: 'dataHora',
    render: text => formatarData(text),
  },
  {
    title: 'Identificador',
    dataIndex: 'identificador',
  },
  {
    title: 'Tipo',
    dataIndex: 'tipo',
    render: text => resolver(text),
  },
  {
    title: 'Status',
    dataIndex: 'reprocessando',
  },
  {
    title: 'Mensagem',
    dataIndex: 'mensagemDeErro',
  },
  {
    title: 'Ações',
    dataIndex: 'acoes',
  },
];
